<template>
  <div class="Ticket">
    <div class="Ticket-body">
      <h5 class="Ticket-title">{{title}}</h5>
      <p class="Ticket-desc">{{desc}}</p>
    </div>
    
    <!--<select class="Ticket-select Select" name="quantity" aria-label="quantity" v-model="quantity">
      <option v-for="n in getNumbers(minTickets, maxTickets)" :key="n" :value="n">
        {{n}}
      </option>
    </select>-->

    <div v-if="price" class="Ticket-price">
      <strong>{{price}}</strong> <s v-if="beforePrice">{{beforePrice}}</s>
    </div>

    <add-to-basket 
      :productId="id" 
      :quantity="quantity" 
      :url="basket"
      :buttonProps="{ 
        class: 'Ticket-btn', 
        isPrimary: true, 
        isBlock: true
      }"/>
  </div>
</template>

<script>
import ButtonVue from '../UI/Button.vue';
import AddToBasket from '../AddToBasket/index.vue';

export default {
  components: { ButtonVue, AddToBasket },

  data: function() {
    return {
      quantity: this.minTickets
    }
  },

  methods: {
    getNumbers(start,stop){
      return new Array((stop+1)-start).fill(start).map((n,i) => n+i);
    }
  },

  props: {
    id: {
      type: Number,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    desc: {
      type: String,
      default: null
    },
    minTickets: {
      type: Number,
      default: null
    },
    maxTickets: {
      type: Number,
      default: null
    },
    price: {
      type: String,
      default: null
    },
    beforePrice: {
      type: String,
      default: null
    },
    basket: {
      type: String,
      default: null
    }
  }
}
</script>